/* Pixel Threads - Geo Links
   Turns any element carrying data-geo into a link to that point on Google
   Maps. Progressive enhancement: the coordinate is already rendered as text
   server-side, so with no JS, a failed parse or a nonsense value, nothing
   changes and nothing breaks. Reads decimal degrees with or without
   hemisphere letters, and degrees/minutes/seconds. */
(function () {
  'use strict';

  var MAPS = 'https://www.google.com/maps/search/?api=1&query=';

  /* One coordinate component: degrees, optional minutes, optional seconds,
     optional hemisphere letter. */
  var PART = /(-?\d+(?:\.\d+)?)\s*(?:°|º|d)?\s*(?:(\d+(?:\.\d+)?)\s*(?:'|\u2032|m)\s*)?(?:(\d+(?:\.\d+)?)\s*(?:"|\u2033|s)\s*)?\s*([NSEW])?/gi;

  function parse(raw) {
    if (!raw) return null;
    var text = String(raw).replace(/[\[\]]/g, ' ').replace(/\s+/g, ' ').trim();
    if (!text) return null;

    var found = [], m;
    PART.lastIndex = 0;
    while ((m = PART.exec(text)) !== null) {
      if (!m[0].trim()) { PART.lastIndex++; continue; }
      var deg = parseFloat(m[1]);
      if (isNaN(deg)) continue;
      var value = Math.abs(deg) + (parseFloat(m[2]) || 0) / 60 + (parseFloat(m[3]) || 0) / 3600;
      var hemi = (m[4] || '').toUpperCase();
      if (hemi === 'S' || hemi === 'W' || deg < 0) value = -value;
      found.push({ value: value, hemi: hemi });
      if (found.length > 2) return null;
    }
    if (found.length !== 2) return null;

    /* Latitude first unless the hemisphere letters say otherwise. */
    var lat = found[0], lng = found[1];
    if (lat.hemi === 'E' || lat.hemi === 'W' || lng.hemi === 'N' || lng.hemi === 'S') {
      lat = found[1]; lng = found[0];
    }
    if (Math.abs(lat.value) > 90 || Math.abs(lng.value) > 180) return null;
    if (lat.value === 0 && lng.value === 0) return null;

    return { lat: round(lat.value), lng: round(lng.value) };
  }

  function round(n) { return Math.round(n * 1e6) / 1e6; }

  function enhance(el) {
    if (!el || el.getAttribute('data-geo-ready') === 'true') return;
    if (el.querySelector('a') || el.closest('a')) return;
    var point = parse(el.getAttribute('data-geo') || el.textContent);
    if (!point) return;

    var link = document.createElement('a');
    link.className = 'pt-geo-link';
    link.href = MAPS + point.lat + ',' + point.lng;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.setAttribute('aria-label', 'Open this location in Google Maps: ' + point.lat + ', ' + point.lng);
    while (el.firstChild) link.appendChild(el.firstChild);
    el.appendChild(link);
    el.setAttribute('data-geo-ready', 'true');
  }

  function run(root) {
    var nodes = (root || document).querySelectorAll('[data-geo]');
    for (var i = 0; i < nodes.length; i++) enhance(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();

  /* Section re-renders in the theme editor, and any future async content. */
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
}());